const updateLanguage = {
  'update-language-submitting-form': 'Cambiando el idioma. Por favor, espere...',
  'update-language-submit-button': 'Cambiar idioma',
  'update-language-title': '¿En qué idioma desea recibir el boletín de novedades?',
  'update-language-success-message': 'El idioma en el cual recibiras el boletín informativo ha sido modificado correctamente'
};

export default updateLanguage;
